import { useContext, useEffect } from 'react'
import cn from 'classnames'
import { Link } from 'react-router-dom'
import BrandingContext from '../context/BrandingContext'

const BoxNav = ({ current, onChange, links }) => {
  const [branding] = useContext(BrandingContext)
  const { primaryColorPalette } = branding

  useEffect(() => {
    if (onChange) {
      links.forEach((link) => {
        if (current.includes(link.to)) {
          onChange(link.key)
        }
      })
    }
  }, [links, current, onChange])

  return (
    <nav className="flex overflow-x-auto space-x-3 px-4">
      {links.map((link) => (
        <Link
          className={cn(
            'relative px-4 pt-6 pb-4 font-medium whitespace-nowrap group text-sm',
            {
              'text-gray-500': !current.includes(link.to),
              'text-gray-900': current.includes(link.to),
            },
          )}
          key={link.to}
          to={link.to}
        >
          {link.label}
          <span
            className={cn(
              'absolute right-0 bottom-0 left-0 h-0.75 rounded-tl-md rounded-tr-md',
              {
                'bg-transparent group-hover:bg-gray-300': !current.includes(
                  link.to,
                ),
                [`bg-${primaryColorPalette}-600`]: current.includes(link.to),
              },
            )}
          />
        </Link>
      ))}
    </nav>
  )
}

export default BoxNav
